import "./ProjectHeroCoffeeShop.scss";

function ProjectHeroCoffeeShop() {
  return (
    <>
      <section class="project-cs-hero">
        <div class="project-cs-hero__content">
          <h1 class="heading-primary">Coffee Shop</h1>
          <div class="project-cs-hero__info">
            <p class="text-primary text-primary--project">
              This is a multi-page website for a Coffee Shop.
            </p>
          </div>
          <div class="project-cs-hero__cta">
            <a
              href="https://supreet-kaur-coffeeshop.netlify.app/"
              class="btn btn--bg"
              target="_blank"
              rel="noreferrer"
            >
              Live Link
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProjectHeroCoffeeShop;
